import { render, staticRenderFns } from "./ClientsCard.vue?vue&type=template&id=2950b84e&scoped=true&"
import script from "./ClientsCard.vue?vue&type=script&lang=js&"
export * from "./ClientsCard.vue?vue&type=script&lang=js&"
import style0 from "./ClientsCard.vue?vue&type=style&index=0&id=2950b84e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2950b84e",
  null
  
)

export default component.exports